export const ONE_STEM_TRANSITION_QUERY_PARAMETER = 'onestem_transition'
export const ONE_STEM_TRANSITION_SOURCE = 'tukios-flowers'

const ONE_STEM_TRANSITION_DISMISSED_KEY = 'onestem-transition-announcement-v1'

interface TransitionMarkerOptions {
  location?: Pick<Location, 'href'>
  history?: { state: unknown; replaceState: History['replaceState'] }
  storage?: Pick<Storage, 'getItem'> | null
}

export function consumeOneStemTransitionMarker({
  location = window.location,
  history = window.history,
  storage,
}: TransitionMarkerOptions = {}): boolean {
  let url

  try {
    url = new URL(location.href)
  } catch {
    return false
  }

  if (url.searchParams.get(ONE_STEM_TRANSITION_QUERY_PARAMETER) !== ONE_STEM_TRANSITION_SOURCE) {
    return false
  }

  url.searchParams.delete(ONE_STEM_TRANSITION_QUERY_PARAMETER)
  history.replaceState(history.state, '', url)

  try {
    // Privacy-restricted browsers can throw when accessing the storage getter itself.
    const browserStorage = storage ?? window.localStorage
    return browserStorage.getItem(ONE_STEM_TRANSITION_DISMISSED_KEY) !== 'dismissed'
  } catch {
    return true
  }
}

export function dismissOneStemTransitionAnnouncement({
  storage,
}: { storage?: Pick<Storage, 'setItem'> | null } = {}): void {
  try {
    const browserStorage = storage ?? window.localStorage
    browserStorage.setItem(ONE_STEM_TRANSITION_DISMISSED_KEY, 'dismissed')
  } catch {
    // Storage can be unavailable in privacy-restricted browsers. Closing still works for this page.
  }
}
